import type { z } from 'zod';
import { toArray } from '@/lib/utils/to-array';
import { ProfileChangeSchema, ProfileChangesResponseSchema } from './schemas';

const DEFAULT_PROFILE_IMAGE_URL = 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png';

export type ProfileChangeInput = z.input<typeof ProfileChangeSchema>;
export type ProfileChangeOutput = z.output<typeof ProfileChangeSchema>;

export function serializeProfileChange(payload: ProfileChangeInput): ProfileChangeOutput {
  const normalized: ProfileChangeInput = {
    ...payload,
    username: payload.username ?? '',
    name: payload.name ?? '',
    description: payload.description ?? null,
    location: payload.location ?? null,
    profileImageUrl: payload.profileImageUrl ?? DEFAULT_PROFILE_IMAGE_URL,
    profileBannerUrl: payload.profileBannerUrl ?? null,
    url: payload.url ?? null,
    verifiedType: payload.verifiedType ?? 'none',
    followersCount: payload.followersCount ?? 0,
    followingCount: payload.followingCount ?? 0,
    isFollowing: payload.isFollowing ?? false,
    followsYou: payload.followsYou ?? false,
    pinnedTweetId: payload.pinnedTweetId ?? null,
    oldUsername: payload.oldUsername ?? null,
    oldName: payload.oldName ?? null,
    oldDescription: payload.oldDescription ?? null,
    oldLocation: payload.oldLocation ?? null,
    oldProfileImageUrl: payload.oldProfileImageUrl ?? null,
    oldUrl: payload.oldUrl ?? null,
    oldVerifiedType: payload.oldVerifiedType ?? null,
    oldFollowersCount: payload.oldFollowersCount ?? null,
    oldFollowingCount: payload.oldFollowingCount ?? null,
    oldPinnedTweetId: payload.oldPinnedTweetId ?? null,
    affiliations: toArray(payload.affiliations),
    primaryAffiliation: payload.primaryAffiliation ?? null,
  };

  return ProfileChangeSchema.parse(normalized);
}

export type ProfileChangesResponseInput = z.input<typeof ProfileChangesResponseSchema>;
export type ProfileChangesResponseOutput = z.output<typeof ProfileChangesResponseSchema>;

export function serializeProfileChangesResponse(payload: ProfileChangesResponseInput): ProfileChangesResponseOutput {
  return ProfileChangesResponseSchema.parse(payload);
}
